import { NgModule, provideBrowserGlobalErrorListeners } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { App } from './app';
import { AppRoutingModule } from './app-routing-module';
import { Categories } from './modules/course-reference/categories/categories';
import { AddCategories } from './modules/course-reference/add-categories/add-categories';
import { SubCategory } from './modules/course-reference/sub-category/sub-category';
import { AddSubCategory } from './modules/course-reference/add-sub-category/add-sub-category';
import { Tags } from './modules/course-reference/tags/tags';
import { AddTag } from './modules/course-reference/add-tag/add-tag';
import { Language } from './modules/course-reference/language/language';
import { AddLanguage } from './modules/course-reference/add-language/add-language';
import { DifficultyLevel } from './modules/course-reference/difficulty-level/difficulty-level';
import { AddDifficultyLevel } from './modules/course-reference/add-difficulty-level/add-difficulty-level';
import { PromotionalTag } from './modules/course-reference/promotional-tag/promotional-tag';
import { AddPromotionalTag } from './modules/course-reference/add-promotional-tag/add-promotional-tag';
import { CourseRules } from './modules/course-reference/course-rules/course-rules';
import { Test } from './shared/test/test';

@NgModule({
  declarations: [
    App,
    Categories,
    AddCategories,
    SubCategory,
    AddSubCategory,
    Tags,
    AddTag,
    Language,
    AddLanguage,
    DifficultyLevel,
    AddDifficultyLevel,
    PromotionalTag,
    AddPromotionalTag,
    CourseRules,
    Test,
  ],
  imports: [BrowserModule, AppRoutingModule, NgbModule],
  providers: [provideBrowserGlobalErrorListeners()],
  bootstrap: [App],
})
export class AppModule {}
